module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic-VariableFont_wght.7d5651a0.ttf";